export default "__VITE_ASSET__DzOobO9y__"